export const removePreferredContact = (preferredContacts: string[], value: string) => {
  return preferredContacts.filter(item => item !== value) || [];
};

export const addPreferredContact = (preferredContacts: string[], value: string) => {
  return [...preferredContacts, value];
};
